<template lang="pug">
  .main
    Hero(:content="heroContent")
    HomeCards
    .container(v-scroll-reveal={origin: 'bottom', distance: '200px'})
      p 社團法人德普文教協會 TEP Culture and Education Association  (簡稱 “德普” 或 “TEP”) 原名「台灣至善文教協會」，是依台灣法規設立、非以營利為目的之社會團體；TEP 的宗旨是在全球各開發中國家地區推廣電腦啟蒙教育及農業合作等國際服務，致力為外交孤立的台灣：開展台灣的國際人道服務 開拓台灣的國際發展空間

</template>

<script>
import Hero from '@/components/Hero'
import HomeCards from '@/components/HomeCards'

export default {
  components: {
    Hero,
    HomeCards
  },
  data () {
    return {
      heroContent: {
        title: '國際服務 服務台灣',
        subTitle: '開展台灣的國際人道服務，開拓台灣的國際發展空間',
        btnUrl: 'https://camtw.eoffering.org.tw/',
        imageNo: 1
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/Home.vue